import * as React from "react";

class AboutComponent extends React.Component {
  render(): JSX.Element {
    return (
      <div className="single-page">
        <div className="page-title">
          <div className="big-title secondary">Our Mission:</div>
          <div className="mission">
            Enable Professionals to find and create instant opportunities
          </div>
          <p className="aboutus">
            At Fikafy, we are so passionate to let you know that the co-founder,
            colleague, employee, employer or any skilled worker <span>you</span> have been looking
            for is living <span>next door</span> and can be reached with just one
            click.
          </p>
        </div>
      </div>
    );
  }
}

export default AboutComponent;



// WEBPACK FOOTER //
// ./src/components/about.component.tsx